import { DatePipe } from '@angular/common';
import { AfterContentChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from "ng-zorro-antd";
import { DOCSO } from 'src/app/fieldTypes/NumToWord';
import { stringFormatToFloat } from 'src/app/fieldTypes/TextFields';
import { CreateIssueModel, FieldTableValue, FieldValue } from 'src/app/models/booking-request.model';
import { FieldTypeCode } from 'src/app/utils/enum';
import { GetInfomationField, GetInfomationForm, RequestParams } from '../../models/forms-get.models';
import { FieldOption, FormFieldInfo, FormInfo } from '../../models/forms-response.models';
import { FormsService } from '../../services/forms.service';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
const STORAGE_STEP = "SACOM_EFORM_CURRENT_STEP";

@Component({
    selector: 'app-component-eform',
    templateUrl: './eform.component.html',
    styleUrls: ['./eform.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EformComponent implements OnInit, AfterContentChecked, AfterViewInit {
    @ViewChild(HeaderComponent) header;
    @ViewChild(FooterComponent) footer;
    @ViewChild('EformData') eformData: ElementRef;
    isSendingData: boolean = true;
    isMobile = window.innerWidth < 1000 ? true : false;
    getFormInfo: GetInfomationForm;
    requestMod: RequestParams;
    getInfomationField: GetInfomationField
    formFieldInfo: FormFieldInfo[];
    formFieldOption: FieldOption[];
    formInfo: FormInfo;
    tmpFieldList: any[] = [];
    formGroup: FormGroup = this.formBuilder.group({});
    customFieldData: FieldValue[] = [];
    multiCheckedList: FieldValue[] = [];
    multiSubCheckedList: FieldValue[] = [];
    multiSubTempList: FieldValue[] = [];
    multiTempList: FieldValue[] = [];
    tableComplexFieldData: FieldTableValue[] = [];
    _isbooking = false;
    _viewAsUser = false;
    listfield = [];
    hasNoListField = false;
    _customer: any;
    valueIssue = [];
    stepWeb = 0;
    stepMobile = 0;
    code: string;
    taxCode: string;
    formName = '';
    customerCode = "";
    customerIdentity = "";
    version: number;
    title: string;
    stepNum: number;
    currentStep: number;
    steps: any[] = [];
    numberFormFieldInfo: any;
    selectChildData: any;
    isFilledTableComplex: boolean = false;
    nameComponentWarning: string = '';
    listMappingCurrency: any[] = [];
    unit: string = "đồng";
    stepProcessing: number = 1;

    constructor(
        private formService: FormsService,
        private nzModalNotification: NzNotificationService,
        private formBuilder: FormBuilder,
        private activeRoute: ActivatedRoute,
        private cdref: ChangeDetectorRef,
        private router: Router,
        private datePipe: DatePipe
    ) { }

    ngAfterViewInit(): void {
        //Active class DN header
        let CNEle = this.header.navEl.nativeElement.children[0].querySelector('a');
        if(CNEle.classList.contains('active')){
            CNEle.classList.remove('active');
        }

        let DNEle = this.header.navEl.nativeElement.children[1].querySelector('a');
        if(!DNEle.classList.contains('active')){
            DNEle.classList.add('active');
        }
        //ACtive class DN footer
        CNEle = this.footer.navEl.nativeElement.children[0].querySelector('a');
        if(CNEle.classList.contains('active')){
            CNEle.classList.remove('active');
        }

        DNEle = this.footer.navEl.nativeElement.children[1].querySelector('a');
        if(!DNEle.classList.contains('active')){
            DNEle.classList.add('active');
        }
    }

    ngOnInit() {
        let currentTaxCode = localStorage.getItem('TAXCODE');
        this.activeRoute.queryParams.subscribe(
            params => {
                this.code = params['code'];
                this.taxCode = params['taxcode'];
                
                localStorage.setItem('FORM_CODE', this.code);
                localStorage.setItem('TAXCODE', this.taxCode);
            }
        )

        if (this.code && this.taxCode) {
            let hour = 24;
            let isTimeOut = false;
            var now = new Date().getTime();
            let setupTime: number = (localStorage.getItem('setupTime') != null) ? parseInt(localStorage.getItem('setupTime')) : 0;
            if (setupTime == 0) {
                localStorage.setItem('setupTime', now.toString());
                this.initDataByTaxCode();
            }
            else {
                if (now - setupTime > hour * 60 * 60 * 1000) {//if localStorage is saved more than 24h => clear
                    localStorage.clear();
                    localStorage.setItem('setupTime', now.toString());
                    localStorage.setItem('FORM_CODE', this.code);
                    localStorage.setItem('TAXCODE', this.taxCode);
                    isTimeOut = true;
                    this.initDataByTaxCode();
                }
                else {
                    if (currentTaxCode) {
                        if (currentTaxCode == this.taxCode) {
                            this.bindDataWithCurrentTaxCode();
                        }
                        else {
                            currentTaxCode = this.taxCode;
                            this.initDataByTaxCode();
                        }
                    }
                    else {
                        this.bindDataWithCurrentTaxCode();
                    }
                }
            }
        }
        else {
            this.router.navigate(['/khdn-bieumau']);
        }
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    bindDataWithCurrentTaxCode() {
        this.getEformByUrlParams();
        this.getCurrencyList();
        let step = localStorage.getItem(STORAGE_STEP + this.code + '_' + this.taxCode);
        this.currentStep = (step) ? parseInt(step) : 0;//init step of Eform
        localStorage.setItem(STORAGE_STEP + this.code + '_' + this.taxCode, this.currentStep.toString());
    }

    initDataByTaxCode() {
        if (this.taxCode) {
            this.getFieldByTaxCode(this.code, this.taxCode);
        }
        else {
            this.router.navigate(['/khdn-bieumau']);
        }
    }

    getEformByUrlParams() {
        this.getFormInfo = { FormCode: this.code }
        this.formService.getFormByCode(this.getFormInfo).subscribe(res => {
            if (res.result.isSuccess && res.result.value.result.isActive) {
                this.formInfo = res.result.value.result;
                this.title = this.formInfo.name;
                this.stepNum = this.formInfo.stepMobile;
                this.version = this.formInfo.versionActive == 0 ? 1 : this.formInfo.versionActive;
                localStorage.setItem('FORM_VERSION', this.version.toString());
                this.getField();
            }
            else {
                this.nzModalNotification.error("Error", "Biểu mẫu chưa được hỗ trợ online");
            }
        }, error => {
            this.nzModalNotification.error("Error", "Biểu mẫu chưa được hỗ trợ online");
        })
    }

    getFieldByTaxCode(code: string, taxcode: string) {
        this.requestMod = { FormCode: code, TaxCode: taxcode }
        this.formService.getFieldByTaxCode(this.requestMod).subscribe(res => {
            if (res.result.isSuccess && res.result.value.result) {
                let listField = res.result.value.result;
                this.tmpFieldList = listField;
                listField.forEach(el => {
                    let fieldCode = el.fieldCode;
                    let fieldValues = el.fieldValues;
                    let rowId = el.rowId;
                    if (rowId == null) {// data doesn't exist in table
                        if (fieldCode.includes(FieldTypeCode.RADIO_BUTTON) || fieldCode.includes(FieldTypeCode.SELECTLIST_SINGLE)) {
                            if (fieldValues) {
                                if (fieldValues.indexOf('|') > 0) {
                                    let optCode = fieldValues.split('|');
                                    if (optCode) {
                                        fieldValues = optCode[0];
                                        if (optCode.length == 3) {
                                            localStorage.setItem('TEMP_' + this.code + '_' + this.taxCode + '_' + fieldCode, optCode[2]);
                                        }
                                    }
                                }
                            }
                        }
                        else if (fieldCode.includes(FieldTypeCode.MULTIPLE_CHOICE)) {
                            if (fieldValues) {
                                let fieldVal = '';
                                if (fieldValues.indexOf('#') > 0) {
                                    let optVals = fieldValues.split('#');
                                    optVals.forEach(element => {
                                        let val = element.split('|');
                                        if (val)
                                            fieldVal += val[0] + ',';
                                    });
                                    fieldVal = fieldVal.slice(0, -1);
                                }
                                else {
                                    let val = fieldValues.split('|');
                                    if (val)
                                        fieldVal = val[0];
                                }
                                fieldValues = fieldVal;
                            }
                        }
                        else if (fieldCode.includes('SYS_')) {
                            if (fieldValues) {
                                if (fieldValues.indexOf('|') > 0) {
                                    let optCode = fieldValues.split('|');
                                    if (optCode) {
                                        fieldValues = optCode[0];
                                        if (optCode.length == 3) {
                                            localStorage.setItem('TEMP_' + this.code + '_' + this.taxCode + '_' + fieldCode, optCode[2]);
                                        }
                                    }
                                }
                            }
                        }
                        if (fieldCode .includes(FieldTypeCode.DATE) || fieldCode.includes('Date')) {
                            if (fieldValues.includes('/')) {
                                const [day, month, year] = fieldValues.split('/');
                                const date = new Date(+year, +month - 1, +day);
                                fieldValues = date.toString();
                            }
                        }
                        localStorage.setItem('VALUE_' + this.code + '_' + this.taxCode + '_' + fieldCode, fieldValues);
                    }
                    else { // data in table

                        let splittedfields = fieldCode.split('_');
                        let index = 0;
                        let nameOfField = '';
                        splittedfields.forEach(element => {
                            if (index == 3)
                                return;
                            nameOfField += element + '_';
                            index++;
                        });
                        nameOfField = nameOfField.substring(0, nameOfField.length - 1);
                        let tmpList = [];
                        let foundList = this.tmpFieldList.filter(x => x.fieldCode.includes(nameOfField));
                        let numberList = [];
                        for (const obj of foundList) {
                            if (numberList.length > 0) {
                                if (numberList.indexOf(obj.rowId) < 0)
                                    numberList.push(obj.rowId);
                            }
                            else {
                                numberList.push(obj.rowId);
                            }
                        }
                        let objTemp: any = {};
                        for (let index = 0; index < numberList.length; index++) {
                            const number = numberList[index];
                            objTemp = {};
                            foundList.forEach(element => {
                                let rowId = element.rowId;
                                if (rowId == number) {
                                    let foundCode = element.fieldCode;
                                    foundCode = foundCode.replace(nameOfField + '_', '');
                                    let foundValue = element.fieldValues;
                                    if (foundCode.includes(FieldTypeCode.DATE) || foundCode.includes('Date')) {
                                        if (foundValue.includes('/')) {
                                            const [day, month, year] = foundValue.split('/');
                                            const date = new Date(+year, +month - 1, +day);
                                            foundValue = date.toString();
                                        }
                                    }
                                    objTemp[foundCode] = foundValue;
                                }
                            });
                            tmpList.push(objTemp);
                        }
                        localStorage.setItem('VALUE_' + this.code + '_' + this.taxCode + '_' + nameOfField, JSON.stringify(tmpList))

                    }
                });
            }
            else {
                this.nzModalNotification.error("Error", "Biểu mẫu chưa được hỗ trợ online");
            }
            this.formGroup = this.formBuilder.group({});
            this.getEformByUrlParams();
            this.getCurrencyList();
            let step = localStorage.getItem(STORAGE_STEP + this.code + '_' + this.taxCode);
            this.currentStep = (step) ? parseInt(step) : 0;//init step of Eform
            localStorage.setItem(STORAGE_STEP + this.code + '_' + this.taxCode, this.currentStep.toString());
        }, error => {
            this.nzModalNotification.error("Error", "Biểu mẫu chưa được hỗ trợ online");
        })
    }

    getCurrencyList() {
        let urlCurrency = "/api/services/app/masterList/CategoryGetMasterListByGroupCode";
        this.formService.callApiUrl(urlCurrency, { input: 'CURRENCY' }).subscribe(
            res => {
                this.listMappingCurrency = res.result;
            },
            error => {
                console.log(error);
            }
        )
    }

    getField() {
        this.getInfomationField = { FormCode: this.formInfo.code, Version: this.version, Enviroment: 2 }
        this.formService.getFieldCreateForm(this.getInfomationField).subscribe(res => {
            if (res.result.isSuccess) {
                this.formFieldInfo = res.result.value.result;
                this.formFieldInfo.map(({ step, stepName }) => {
                    if (this.steps.filter(x => x.step == step).length == 0) {
                        this.steps.push({ step, stepName })
                    }
                });
                this.steps = this.steps.sort((a, b) => (a.step < b.step ? -1 : 1));
                this.formFieldInfo.forEach((value, index) => {
                    if (value.fieldTypeCode != FieldTypeCode.TITLE && value.fieldTypeCode != FieldTypeCode.LABEL) {
                        if (value.fieldTypeCode == FieldTypeCode.MULTIPLE_CHOICE) {
                            this.formGroup.addControl(value.fieldCode, new FormControl({ value: '', disabled: value.isReadonly ? true : false }, value.isRequired ? Validators.required : null));

                            if (value.customfieldOptionList && value.customfieldOptionList.length > 0) {
                                value.customfieldOptionList.forEach(opt => {
                                    this.formGroup.addControl(opt.fieldCode + '-' + opt.optionCode, new FormControl());
                                });
                            }
                        }
                        else if (value.fieldTypeCode == FieldTypeCode.RADIO_BUTTON) {
                            this.formGroup.addControl(value.fieldCode, new FormControl({ value: '', disabled: value.isReadonly ? true : false }, value.isRequired ? Validators.required : null));

                            if (value.customfieldOptionList && value.customfieldOptionList.length > 0) {
                                value.customfieldOptionList.forEach(opt => {
                                    this.formGroup.addControl(opt.fieldCode + '-' + opt.optionCode + '_INPUT', new FormControl());
                                });
                            }
                        }
                        else {
                            this.formGroup.addControl(value.fieldCode, new FormControl({ value: '', disabled: value.isReadonly ? true : false }, value.isRequired ? Validators.required : null));
                        }
                    }
                });

            }
            else {
                this.nzModalNotification.error("Error", "Biểu mẫu chưa được hỗ trợ online");
            }
        }, error => {
            this.nzModalNotification.error("Error", "Biểu mẫu chưa được hỗ trợ online");
        })
    }

    isShowComponent(component: FormFieldInfo) {
        if (component.formFieldConfig && JSON.parse(component.formFieldConfig)) {
            var itemSubSection = JSON.parse(component.formFieldConfig).itemSubSection ? JSON.parse(component.formFieldConfig).itemSubSection : null;
            if (itemSubSection) {
                return false;
            }
        }
        return true;
    }

    isHidden(component: FormFieldInfo) {
        if (component.step == this.currentStep + 1) {
            return false;
        }
        return true;
    }

    getSubItemsList(component: FormFieldInfo) {
        let fieldCode = component.fieldCode;
        if (this.formFieldInfo) {
            var itemList = this.formFieldInfo.filter(x => {
                if (x.formFieldConfig) {
                    let config = JSON.parse(x.formFieldConfig)
                    if (config && config.itemSubSection) {
                        for (const opt of component.customfieldOptionList) {
                            if (config.itemSubSection == opt.fieldCode + '-' + opt.optionCode) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            });
        } else {
            itemList = [];
        }
        return itemList;
    }

    getMultipleChoiceCustomfieldList(component: FormFieldInfo) {
        var fieldCode = component.fieldCode;
        let formFieldInfo = this.formFieldInfo.filter(x => {
            let fieldConfig = (x.fieldConfig && x.fieldConfig.indexOf('dependentField') > -1) ? JSON.parse(x.fieldConfig) : null;
            if (fieldConfig && fieldConfig.dependentField) {
                return fieldConfig.dependentField.indexOf(component.fieldCode) > -1;
            }
            return false;
        });
        let filteredFormFieldInfo = (formFieldInfo != null) ? formFieldInfo[0] : null;

        if (filteredFormFieldInfo) {
            var filteredCustomfieldOptionList = filteredFormFieldInfo.customfieldOptionList.filter(x => {
                let fieldOptionConfig = x.fieldOptionConfig ? JSON.parse(x.fieldOptionConfig) : null;
                if (fieldOptionConfig) {
                    let depenentOptions = fieldOptionConfig.dependentFieldsOption.filter(y => y.fieldCode == fieldCode);
                    let dependentFieldsOption = (depenentOptions != null) ? depenentOptions[0] : null;
                    return dependentFieldsOption.fieldCode == fieldCode;
                }
                return false;
            });
        }
        return filteredCustomfieldOptionList;
    }

    numberAddEvent(value) {
        this.numberFormFieldInfo = value;
    }

    selectOutput(item) {
        this.selectChildData = [];
        if (item) {
            var childField = this.formFieldInfo.find(x => {
                if (x.fieldConfig) {
                    var config = (x.fieldConfig && x.fieldConfig.indexOf('input') > -1) ? JSON.parse(x.fieldConfig) : null;
                    var parentId = config && config.apiConfig && config.apiConfig.request ? config.apiConfig.request.input : '';
                    if (item.fieldInfo.fieldCode == parentId)
                        return true;
                }
                return false;
            })
            if (childField) {
                this.selectChildData = { fieldCode: childField.fieldCode, data: [] };
                let fieldConfig = childField.fieldConfig ? JSON.parse(childField.fieldConfig) : null;
                var data = localStorage.getItem(fieldConfig.apiConfig.url + JSON.stringify(fieldConfig.apiConfig.request) + JSON.stringify(fieldConfig.apiConfig.request.input));
                if (data && data != '[]') {
                    this.selectChildData = { fieldCode: childField.fieldCode, data: JSON.parse(data) };
                } else {
                    if (fieldConfig && fieldConfig.apiConfig.url && !fieldConfig.apiConfig.prefix) {
                        if (item.input && item.input.dataValueField) {
                            this.formService.callApiUrl(fieldConfig.apiConfig.url, { input: item.input.dataValueField }).subscribe(
                                res => {
                                    if (res.result && res.result.length > 0) {
                                        this.selectChildData = { fieldCode: childField.fieldCode, data: res.result };
                                    }
                                },
                                error => {
                                    console.log(error);
                                }
                            )
                        }
                    } else if (fieldConfig && fieldConfig.apiConfig.url && fieldConfig.apiConfig.prefix) {
                        if (item.input && item.input.dataValueField) {
                            this.formService.callApiUrl(fieldConfig.apiConfig.url, { input: fieldConfig.apiConfig.prefix + item.input.dataValueField }).subscribe(
                                res => {
                                    if (res.result && res.result.length > 0) {
                                        this.selectChildData = { fieldCode: childField.fieldCode, data: res.result };
                                    }
                                },
                                error => {
                                    console.log(error);
                                }
                            )
                        }
                    }
                }
            }
        }

    }

    tableOutput(e) {
        this.formGroup.controls[e.fieldCode].setValue(e.value);
    }

    getCol(item: any) {
        if (item.step == this.currentStep + 1) {
            if (item.fieldTypeCode == FieldTypeCode.TITLE) {
                return 'col-md-12';
            }
            else {
                return 'col-md-' + (item.width * 12 / 3) + ' col-xs-12';
            }
        }
    }

    pre() {
        this.currentStep -= 1;
        localStorage.setItem(STORAGE_STEP + this.code + '_' + this.taxCode, this.currentStep.toString());
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }

    next() {
        this.currentStep += 1;
        this.stepProcessing += 1;
        localStorage.setItem(STORAGE_STEP + this.code + '_' + this.taxCode, this.currentStep.toString());
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }

    submitForm() {
        this.customFieldData = [];
        let formCode = this.code;
        let env = this.version;
        let dataForm = this.formGroup.value;
        let rawData = this.formGroup.getRawValue();
        if (this.validate(this.formFieldInfo)) {
            this.mappingObjectFromGroupData(dataForm);
            var radioComponents: any = (<HTMLInputElement><unknown>document.querySelectorAll('app-component-radiobutton.parent-section'));
            radioComponents.forEach(rad => {
                let radioGroup = rad.querySelectorAll('nz-form-control nz-radio-group label');
                radioGroup.forEach(radComponent => {
                    let rawId = radComponent.id;
                    rawId = rawId.replace('multi', '');
                    let arrayIds = rawId.split('-');
                    let id = arrayIds[0];
                    let code = arrayIds[1];
                    let radioClass = radComponent.className;
                    if (radioClass.includes('ant-radio-wrapper-checked')) {
                        var valueofRadio = code;
                        var labelofRadio = radComponent.getAttribute('data-optionvalue');
                        var inputInRadio = rad.querySelector('nz-form-control nz-radio-group#' + id + ' > input');
                        let radioInput = "";
                        if (inputInRadio != null)
                            radioInput = inputInRadio.value;
                        let objectIssue = new FieldValue();
                        objectIssue.rowId = null;
                        objectIssue.code = id;
                        if (radioInput.trim() != "")
                            objectIssue.value = valueofRadio + '|' + labelofRadio + '|' + radioInput;
                        else
                            objectIssue.value = valueofRadio + '|' + labelofRadio;
                        this.customFieldData.push(objectIssue);
                        this.getSubValues(id, valueofRadio, this.formFieldInfo, 0);
                    }
                });
            });

            var radioComponents: any = (<HTMLInputElement><unknown>document.querySelectorAll('app-component-radiobutton nz-form-control'));
            radioComponents.forEach(rad => {
                let radioGroup = rad.querySelectorAll('nz-form-control nz-radio-group label');
                radioGroup.forEach(radComponent => {
                    let rawId = radComponent.id;
                    rawId = rawId.replace('multi', '');
                    let arrayIds = rawId.split('-');
                    let id = arrayIds[0];
                    let code = arrayIds[1];
                    let radioClass = radComponent.className;
                    if (radioClass.includes('ant-radio-wrapper-checked')) {
                        var valueofRadio = code;
                        var labelofRadio = radComponent.getAttribute('data-optionvalue');
                        var inputInRadio = rad.querySelector('nz-form-control nz-radio-group#' + id + ' > input');
                        let radioInput = "";
                        if (inputInRadio != null)
                            radioInput = inputInRadio.value;
                        let objectIssue = new FieldValue();
                        objectIssue.rowId = null;
                        objectIssue.code = id;
                        if (radioInput.trim() != "")
                            objectIssue.value = valueofRadio + '|' + labelofRadio + '|' + radioInput;
                        else
                            objectIssue.value = valueofRadio + '|' + labelofRadio;
                        this.customFieldData.push(objectIssue);
                        this.getSubValues(id, valueofRadio, this.formFieldInfo, 0);
                    }
                });
            });

            this.multiCheckedList = [];
            var multipleComponents: any = (<HTMLInputElement><unknown>document.querySelectorAll('app-component-multiple-choice.parent-section div label'));
            multipleComponents.forEach(multi => {
                let id = multi.getAttribute('data-name');
                if (id != null && id.indexOf('-') > -1)
                    id = id.substring(0, id.indexOf('-'));
                let labelVal = multi.getAttribute('data-multicheckbox');;
                let isSticked = multi.getAttribute('data-checked');
                let value = multi.getAttribute('data-nzValue');
                if (isSticked === "true") {
                    let objectIssue = new FieldValue();
                    objectIssue.rowId = null;
                    objectIssue.code = id;
                    objectIssue.value = value + '|' + labelVal;
                    this.multiCheckedList.push(objectIssue);
                    this.getSubValues(id, value, this.formFieldInfo, 1);
                }
            });

            var multipleFormComponents: any = (<HTMLInputElement><unknown>document.querySelectorAll('app-component-multiple-choice.parent-section nz-form-control div label'));
            multipleFormComponents.forEach(multi => {
                let id = multi.getAttribute('data-name');
                if (id != null && id.indexOf('-') > -1)
                    id = id.substring(0, id.indexOf('-'));
                let labelVal = multi.getAttribute('data-multicheckbox');;
                let isSticked = multi.getAttribute('data-checked');
                let value = multi.getAttribute('data-nzValue');
                if (isSticked === "true") {
                    let objectIssue = new FieldValue();
                    objectIssue.rowId = null;
                    objectIssue.code = id;
                    objectIssue.value = value + '|' + labelVal;
                    this.multiCheckedList.push(objectIssue);
                    this.getSubValues(id, value, this.formFieldInfo, 1);
                }
            });

            //handle select multiple-checkbox (stick checkbox >1)
            this.multiTempList = [];
            this.multiCheckedList.forEach((key, index) => {
                let multiCheckedId = key.code;
                let multiCheckedValue = '';
                this.multiCheckedList.forEach(element => {
                    if (multiCheckedId == element.code)
                        multiCheckedValue += '#' + element.value;

                });
                if (multiCheckedValue.indexOf('#') > -1) {
                    multiCheckedValue = multiCheckedValue.trim().substring(1);
                }
                let objectTempIssue = new FieldValue();
                objectTempIssue.rowId = null;
                objectTempIssue.code = multiCheckedId;
                objectTempIssue.value = multiCheckedValue;
                if (this.multiTempList.length == 0) {
                    this.multiTempList.push(objectTempIssue);
                    this.customFieldData.push(objectTempIssue);
                }
                else {
                    let checkedIndex: number = this.multiTempList.findIndex(el => el.code == multiCheckedId);
                    if (checkedIndex == -1) {
                        this.multiTempList.push(objectTempIssue);
                        this.customFieldData.push(objectTempIssue);
                    }
                }
            })

            if (this.nameComponentWarning != '') {
                this.nameComponentWarning = '';
                return;
            }
            
            let arrFiltered = [];
            this.customFieldData.forEach(data => {
                if(!data.code.includes('SYS_')){
                    if(typeof data.value === 'string' && data.value)
                        data.value = data.value.trim();

                    if(arrFiltered.findIndex(x => x.code == data.code) < 0)
                        arrFiltered.push(data);
                }
            })

            let eformIssueModel = new CreateIssueModel();

            eformIssueModel.formCode = formCode;
            eformIssueModel.environment = env;
            eformIssueModel.customerIdentity = rawData.SYS_CustomerIdentity;
            eformIssueModel.customerName = this.fillData('SYS_CustomerName', false);
            eformIssueModel.phone = this.fillData('SYS_Phone', false);
            eformIssueModel.email = this.fillData('SYS_Email', false);
            eformIssueModel.placeOfIssue = this.fillData('TEXT_PlaceOfIssue', false);
            eformIssueModel.nationality = this.fillData('SYS_Nationality', true);
            eformIssueModel.gender = this.fillData('SELECTLIST_SINGLE_Gender', true);
            eformIssueModel.permanentAddress = this.fillData('SELECTLIST_SINGLE_PermanentAddressCurr', true);
            eformIssueModel.dateOfBirth = (dataForm.SYS_DateOfBirth ? this.datePipe.transform(dataForm.SYS_DateOfBirth, 'dd/MM/yyyy HH:mm') : (rawData.SYS_DateOfBirth ? this.datePipe.transform(rawData.SYS_DateOfBirth, 'dd/MM/yyyy HH:mm') : null));
            eformIssueModel.dateOfIssue = (dataForm.DATE_DateOfIssue ? this.datePipe.transform(dataForm.DATE_DateOfIssue, 'dd/MM/yyyy HH:mm') : (rawData.DATE_DateOfIssue ? this.datePipe.transform(rawData.DATE_DateOfIssue, 'dd/MM/yyyy HH:mm') : null));
            eformIssueModel.currentAddress = this.fillData('SYS_CurrentAddress', false);
            eformIssueModel.currentAddressCountry = this.fillData('SYS_CurrentAddressCountry', true);
            eformIssueModel.currentAddressProvince = this.fillData('SYS_CurrentAddressProvince', true);
            eformIssueModel.currentAddressDistrict = this.fillData('SYS_CurrentAddressDistrict', true);
            eformIssueModel.homeNo = this.fillData('TEXT_HomeNoEdit', false);
            eformIssueModel.occupation = this.fillData('SELECTLIST_SINGLE_CAOccupation', true);
            eformIssueModel.position = this.fillData('SELECTLIST_SINGLE_Position01', false);
            eformIssueModel.companyName = this.fillData('TEXT_CompanyName', false);
            eformIssueModel.companyAddress = this.fillData('SYS_CompanyAddress', false);
            eformIssueModel.permanentAddressCountry = this.fillData('SYS_PermanentAddressCountry', true);
            eformIssueModel.permanentAddressProvince = this.fillData('SYS_PermanentAddressProvince', true);
            eformIssueModel.permanentAddressDistrict = this.fillData('SYS_PermanentAddressDistrict', true);
            eformIssueModel.customFieldData = arrFiltered;
            this.createIssue(eformIssueModel);
        }
    }

    fillData(input: any, hasDataValueField: boolean){
        let dataForm = this.formGroup.value;
        let rawData = this.formGroup.getRawValue();

        if(dataForm[input] !== undefined){
            return hasDataValueField ? dataForm[input].dataValueField : dataForm[input];
        }
        else if(rawData[input] !== undefined){
            return hasDataValueField ? rawData[input].dataValueField : rawData[input];
        }
        
        return null;
    }

    getSubValues(selectedId: any, selectedValue: any, listfield: FormFieldInfo[], isMulti: any): any {
        for (const el of listfield) {
            let component_config = el.formFieldConfig ? JSON.parse(el.formFieldConfig) : "";
            let component_name = (component_config && component_config.displayText) ? component_config.displayText : el.name;
            let itemSubSection = component_config ? component_config.itemSubSection : "";
            let selectedSubSection = selectedId + '-' + selectedValue;
            if (selectedSubSection == itemSubSection) {
                if (itemSubSection) {
                    if (el.formFieldConfig.includes('itemSubSection')) {
                        if (el.fieldTypeCode == FieldTypeCode.MULTIPLE_CHOICE) {
                            let code = "";
                            let value = "";
                            for (const opt of el.customfieldOptionList) {
                                if (opt.checked) {
                                    code = el.fieldCode;
                                    value += opt.optionCode + '|' + opt.optionValue + '#';
                                    if (opt.hasSubSession) {
                                        let idTable = '';
                                        let tableFieldCode = (<HTMLInputElement><unknown>document.querySelector('app-component-multiple-choice#' + el.fieldCode + ' nz-table'));
                                        if (tableFieldCode != null) {
                                            idTable = tableFieldCode.id;
                                            let tableName = (<HTMLInputElement><unknown>document.querySelector('app-component-multiple-choice#' + el.fieldCode + ' div.table-name').textContent.replace(/[(*)]/g, '').trim());
                                            this.getDataFromTableComplex(idTable, tableName, el);
                                        }

                                    }
                                }
                            }
                            if (value != '') {
                                if (value.lastIndexOf('#')) {
                                    value = value.slice(0, -1);
                                }
                                let objectIssue = new FieldValue();
                                objectIssue.rowId = null;
                                objectIssue.code = code;
                                objectIssue.value = value;
                                this.customFieldData.push(objectIssue);
                            }
                            this.getGrandChildrenOfCheckedData(el.fieldCode, FieldTypeCode.MULTIPLE_CHOICE);
                        }
                        else if (el.fieldTypeCode == FieldTypeCode.RADIO_BUTTON) {
                            for (const opt of el.customfieldOptionList) {
                                if (this.formGroup.controls[el.fieldCode].value != undefined) {
                                    var checkedRadio = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value : null;
                                    if (checkedRadio == opt.optionCode) {
                                        let objectIssue = new FieldValue();
                                        objectIssue.rowId = null;
                                        objectIssue.code = el.fieldCode;
                                        objectIssue.value = opt.optionCode + '|' + opt.optionValue;
                                        let inputInSubRadio: any = (<HTMLInputElement><unknown>document.querySelectorAll('app-component-radiobutton nz-form-control nz-radio-group#' + el.fieldCode + ' > input'));
                                        let radioInput = '';
                                        if (inputInSubRadio != null && inputInSubRadio.length > 0) {
                                            radioInput = inputInSubRadio[0].value;
                                        }
                                        if (radioInput != '') {
                                            objectIssue.value = opt.optionCode + '|' + opt.optionValue + '|' + radioInput;
                                        }
                                        else {
                                            objectIssue.value = opt.optionCode + '|' + opt.optionValue;
                                        }
                                        this.customFieldData.push(objectIssue);
                                        this.getGrandChildrenOfCheckedData(el.fieldCode, FieldTypeCode.RADIO_BUTTON);
                                    }
                                }
                            }
                        }
                        else if (el.fieldTypeCode == FieldTypeCode.TABLE_COMPLEX) {
                            this.getDataFromTableComplex(el.fieldCode, component_name, el);
                        }
                        else if (el.fieldTypeCode == FieldTypeCode.LABEL || el.fieldTypeCode == FieldTypeCode.TITLE) {

                        }
                        else if (el.fieldTypeCode == FieldTypeCode.SELECTLIST_SINGLE) {
                            if (this.formGroup.controls[el.fieldCode].value != undefined) {
                                let valueField = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value.dataValueField : null;
                                let textField = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value.dataTextField : null;
                                let objectIssue = new FieldValue();
                                objectIssue.rowId = null;
                                objectIssue.code = el.fieldCode;
                                objectIssue.value = (valueField) ? valueField + '|' + textField : '';
                                this.customFieldData.push(objectIssue);
                            }
                        }
                        else if (el.fieldTypeCode.indexOf(FieldTypeCode.NUMBER_CURRENCY) > -1 || el.fieldTypeCode.indexOf(FieldTypeCode.NUMBER) > -1) {
                            let valOfField = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value : null;
                            let numVal = (valOfField != '') ? valOfField.replace(/[*^'!,]/g, '') : null;
                            let objectIssue = new FieldValue();
                            objectIssue.rowId = null;
                            objectIssue.code = el.fieldCode;
                            objectIssue.value = numVal;
                            this.customFieldData.push(objectIssue);
                            if (numVal != null && numVal != 0) {
                                var unittmp = "VND";
                                if (this.listMappingCurrency.includes(el.fieldCode)) {
                                    unittmp = this.unit;
                                }
                                var objText = new FieldValue();
                                objText.rowId = null;
                                objText.code = el.fieldCode + "TEXT";
                                objText.value = DOCSO.doc(numVal, unittmp);
                                this.customFieldData.push(objText);
                                var objTextEn = new FieldValue();
                                objTextEn.rowId = null;
                                objTextEn.code = el.fieldCode + "TEXTEN";
                                objTextEn.value = DOCSO.docEn(stringFormatToFloat(numVal), unittmp);
                                this.customFieldData.push(objTextEn);
                            }
                        }
                        else {
                            let val = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value : null;
                            if (el.fieldTypeCode.indexOf('Date') > -1 || el.fieldTypeCode.indexOf('DATE') > -1) {
                                let dateVal = val;
                                val = (dateVal != null && dateVal != '') ? this.datePipe.transform(dateVal, 'dd/MM/yyyy').toString() : null;
                                let dateIsoVal = (val != null && val != '') ? val.split('/').reverse().join('-') : null;
                                let objectIsoIssue = new FieldValue();
                                objectIsoIssue.rowId = null;
                                objectIsoIssue.code = el.fieldCode + 'ISO';
                                objectIsoIssue.value = dateIsoVal;
                                this.customFieldData.push(objectIsoIssue);
                            }
                            let objectIssue = new FieldValue();
                            objectIssue.rowId = null;
                            objectIssue.code = el.fieldCode;
                            objectIssue.value = val;
                            this.customFieldData.push(objectIssue);
                        }
                    }

                }
            }
        }
    }

    getDataFromTableComplex(fieldCode: any, component_name: any, dataConfig: any) {
        let tableComplex: any = (<HTMLInputElement><unknown>document.querySelector('nz-table#' + fieldCode + ' div table'));
        let rowsLength = tableComplex.rows.length;
        if (rowsLength == 1) {
            this.isFilledTableComplex = false;
            if (this.nameComponentWarning == '' || this.nameComponentWarning != component_name) {
                this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                this.nameComponentWarning = component_name;
            }
            return;
        }
        this.isFilledTableComplex = true;
        this.tableComplexFieldData = [];
        for (let i = 1; i < rowsLength; i++) {
            let rowId = i - 1;
            for (let j = 1; j <= tableComplex.rows[i].cells.length - 1; j++) {
                let rowVals = new FieldValue();
                let headerName = tableComplex.rows[0].cells[j].id;
                let dataCode = tableComplex.rows[i].cells[j].getAttribute('data-code');
                let cellVal = dataCode ? dataCode : tableComplex.rows[i].cells[j].innerHTML;
                rowVals.rowId = rowId;
                rowVals.code = fieldCode + '_' + headerName;
                if (headerName.includes(FieldTypeCode.SELECTLIST_SINGLE) || headerName.includes(FieldTypeCode.RADIO_BUTTON) || headerName.includes(FieldTypeCode.CHECK_BOX)) {
                    if (dataCode) {//not using for cases SMS and Email...
                        cellVal = dataCode;
                    }
                }

                if (headerName.includes(FieldTypeCode.MULTIPLE_CHOICE) && cellVal) {
                    let temp: string = cellVal.trim();
                    let rs: string = '';

                    if(temp.includes('SMS') || temp.includes('EMAIL')){
                        if(temp.includes('#')){
                            let arrTemp: string[] = temp.split('#');
                            arrTemp.forEach(el => {
                                if(el.includes('SMS'))
                                    rs += el.trim().replace('SMS:','SMS|SMS|');
                                else if(el.includes('EMAIL')){
                                    rs = rs.concat('#');
                                    rs += el.trim().replace('EMAIL:','EMAIL|EMAIL|');
                                }
                            })
                        }
                        else if(temp.includes('SMS') || temp.includes('EMAIL')){
                            rs += temp.replace('SMS:','SMS|SMS|').replace('EMAIL:','EMAIL|EMAIL|');
                        }
                        cellVal = rs;
                    }
                }
                
                rowVals.value = cellVal;
                this.customFieldData.push(rowVals);
                
                if (headerName.includes(FieldTypeCode.DATE)) {
                    let dateVal = cellVal;
                    cellVal = (dateVal != null && dateVal != '') ? dateVal.split('/').reverse().join('-') : null;
                    let objectIsoIssue = new FieldValue();
                    objectIsoIssue.rowId = rowId;
                    objectIsoIssue.code = fieldCode + '_' + headerName + 'ISO';
                    objectIsoIssue.value = cellVal;
                    this.customFieldData.push(objectIsoIssue);
                }
                else if (headerName.indexOf(FieldTypeCode.NUMBER_CURRENCY) > -1 || headerName.indexOf(FieldTypeCode.NUMBER) > -1) {
                    let valOfField = cellVal;
                    let numVal = (valOfField != '') ? valOfField.replace(/[*^'!,]/g, '') : null;
                    if (numVal != null && numVal != 0) {
                        var unittmp = "VND";
                        if (this.listMappingCurrency.includes(fieldCode)) {
                            unittmp = this.unit;
                        }
                        var objText = new FieldValue();
                        objText.rowId = rowId;
                        objText.code = fieldCode + '_' + headerName + "TEXT";
                        objText.value = DOCSO.doc(numVal, unittmp);
                        this.customFieldData.push(objText);
                        var objTextEn = new FieldValue();
                        objTextEn.rowId = rowId;
                        objTextEn.code = fieldCode + '_' + headerName + "TEXTEN";
                        objTextEn.value = DOCSO.docEn(stringFormatToFloat(numVal), unittmp);
                        this.customFieldData.push(objTextEn);
                    }
                }
            }
        }
    }
    getGrandChildrenOfCheckedData(selectedId: any, type: any) {
        if (type === FieldTypeCode.MULTIPLE_CHOICE) {
            var multipleComponent: any = (<HTMLInputElement><unknown>document.querySelector('app-component-multiple-choice#' + selectedId + ' nz-form-control label'));
            let isSticked = multipleComponent.getAttribute('data-checked');
            let value = multipleComponent.getAttribute('data-nzValue');
            if (isSticked === "true") {
                this.getSubValues(selectedId, value, this.formFieldInfo, 1);
            }
        }
        else {
            var radioComponent: any = (<HTMLInputElement><unknown>document.querySelector('app-component-radiobutton#' + selectedId + ' nz-radio-group'));
            var valueofRadio = radioComponent.getAttribute('data-value');
            if (valueofRadio != null && valueofRadio != undefined && valueofRadio != "undefined") {
                let id = radioComponent.getAttribute('id')
                this.getSubValues(id, valueofRadio, this.formFieldInfo, 0);
            }
        }
    }

    mappingObjectFromGroupData(fg: FormGroup) {
        this.customFieldData = [];
        const keys = Object.keys(fg);
        var selectorComponent: any = "";
        var selectorValue: any = "";
        keys.forEach((key, index) => {
            let objectIssue = new FieldValue();
            objectIssue.rowId = null;
            objectIssue.code = key;
            objectIssue.value = fg[key];
            if (!key.includes(FieldTypeCode.RADIO_BUTTON) && !key.includes(FieldTypeCode.MULTIPLE_CHOICE)) {
                if (!key.includes('TABLE')) {
                    if (key.includes(FieldTypeCode.TEXT)) {
                        selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-text.main-form#' + key));
                        if (selectorComponent != null) {
                            selectorValue = this.formGroup.controls[key].value;
                        }
                    }
                    else if (key.includes(FieldTypeCode.NUMBER)) {
                        selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-number.main-form#' + key));
                        if (selectorComponent != null) {
                            selectorValue = this.formGroup.controls[key].value;
                        }
                    }
                    else if (key.includes(FieldTypeCode.TEXTAREA)) {
                        selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-textarea.main-form#' + key));
                        if (selectorComponent != null) {
                            selectorValue = this.formGroup.controls[key].value;
                        }
                    }
                    else if (key.includes(FieldTypeCode.DATE)) {
                        selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-date.main-form#' + key));
                        if (selectorComponent != null) {
                            selectorValue = this.formGroup.controls[key].value;
                        }
                    }
                    else if (key.includes(FieldTypeCode.DATETIME)) {
                        selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-datetime.main-form#' + key));
                        if (selectorComponent != null) {
                            selectorValue = this.formGroup.controls[key].value;
                        }
                    }
                    else if (key.includes(FieldTypeCode.SELECTLIST_SINGLE)) {
                        selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-single-select.main-form#' + key));
                        if (selectorComponent != null) {
                            selectorValue = this.formGroup.controls[key].value;
                        }

                    }
                    else if (key.includes(FieldTypeCode.CHECK_BOX)) {
                        selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-checkbox.main-form#' + key));
                        if (selectorComponent != null) {
                            let valueCheckbox = selectorComponent.querySelector('label').getAttribute('data-value');
                            selectorValue = valueCheckbox;
                        }
                    }
                    else if (key.includes(FieldTypeCode.NUMBER_CURRENCY)) {
                        selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-number-currency.main-form#' + key));
                        if (selectorComponent != null) {
                            selectorValue = this.formGroup.controls[key].value;
                        }
                    }
                    else if (key.includes(FieldTypeCode.TEXT_CHECK_BOX)) {
                        selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-text-checkbox.main-form#' + key));
                        if (selectorComponent != null) {
                            selectorValue = this.formGroup.controls[key].value;
                        }
                    }
                    else if (key.includes(FieldTypeCode.DATE_CHECK_BOX)) {
                        selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-date-checkbox.main-form#' + key));
                        if (selectorComponent != null) {
                            selectorValue = this.formGroup.controls[key].value;
                        }
                    }
                    else if (key.includes('SYS_')) {
                        if (fg[key] != undefined && typeof fg[key] == 'object') {
                            selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-single-select.main-form#' + key));
                            if (selectorComponent != null) {
                                selectorValue = this.formGroup.controls[key].value;
                            }
                        }
                        else {
                            selectorComponent = (<HTMLInputElement><unknown>document.querySelector('app-component-text.main-form#' + key));
                            if (selectorComponent != null) {
                                selectorValue = this.formGroup.controls[key].value;
                            }
                        }

                    }
                    //handle data after checking
                    if (selectorComponent != null) {
                        objectIssue.value = selectorValue;
                        if (selectorValue != undefined && typeof selectorValue == 'object') {
                            objectIssue.value = (selectorValue.dataValueField) ? selectorValue.dataValueField + '|' + selectorValue.dataTextField : '';
                        }
                        else {
                            if (selectorValue != "") {
                                if (key.indexOf('Date') > -1 || key.indexOf('DATE') > -1) {
                                    let dateVal = selectorValue;
                                    objectIssue.value = (dateVal != null && dateVal != '') ? this.datePipe.transform(dateVal, 'dd/MM/yyyy HH:mm').toString() : null;
                                    let dateIsoVal = (objectIssue.value != null && objectIssue.value != '') ? objectIssue.value.split('/').reverse().join('-') : null;
                                    let objectIsoIssue = new FieldValue();
                                    objectIsoIssue.rowId = null;
                                    objectIsoIssue.code = key + 'ISO';
                                    objectIsoIssue.value = dateIsoVal;
                                    this.customFieldData.push(objectIsoIssue);
                                }
                                if (key.indexOf(FieldTypeCode.NUMBER_CURRENCY) > -1 || key.indexOf(FieldTypeCode.NUMBER) > -1) {
                                    let value = selectorValue.replace(/[*^'!,]/g, '');
                                    var unittmp = "VND";
                                    if (this.listMappingCurrency.includes(key)) {
                                        unittmp = this.unit;
                                    }
                                    var objText = new FieldValue();
                                    objText.rowId = null;
                                    objText.code = key + "TEXT";
                                    objText.value = DOCSO.doc(value, unittmp);
                                    this.customFieldData.push(objText);
                                    var objTextEn = new FieldValue();
                                    objTextEn.rowId = null;
                                    objTextEn.code = key + "TEXTEN";
                                    objTextEn.value = DOCSO.docEn(stringFormatToFloat(value), unittmp);
                                    this.customFieldData.push(objTextEn);
                                }
                            }
                        }
                        this.customFieldData.push(objectIssue);
                    }
                }
            }
        });
    }

    nextToEformCompleted() {
        this.router.navigate(['/eform-completed']);
    }

    createIssue(createIssue: CreateIssueModel) {
        this.isSendingData = false;
        this.formService.createIssue(createIssue).subscribe(res => {
            if (res.result.isSuccess) {
                this.isSendingData = true;
                this.nextToEformCompleted();
            }
            else {
                this.isSendingData = true;
                this.nzModalNotification.error("Error", res.result.error);
            }
        }, error => {
            this.isSendingData = true;
            this.nzModalNotification.error("Error", error);
        })
    }

    validate(listfield: FormFieldInfo[]): boolean {
        for (const el of listfield) {
            if ((<HTMLInputElement>document.getElementById(`${el.fieldCode}`))) {
                let component_config = el.formFieldConfig ? JSON.parse(el.formFieldConfig) : "";
                let component_name = (component_config && component_config.displayText) ? component_config.displayText : el.name;
                let itemSubSection = component_config ? component_config.itemSubSection : "";
                if (el.isRequired) {
                    if (itemSubSection) {
                        if (this.hasValue("", itemSubSection)) {
                            if (!el.fieldCode.includes(FieldTypeCode.TABLE_COMPLEX)) {
                                if (!this.hasSubValue(el.fieldCode)) {
                                    this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                                    return false;
                                }
                                else {
                                    if (el.fieldTypeCode == FieldTypeCode.MULTIPLE_CHOICE) {
                                        let optionCount = 0;
                                        for (const opt of el.customfieldOptionList) {
                                            let isChecked = this.formGroup.controls[el.fieldCode + '-' + opt.optionCode].value;
                                            if (isChecked) {
                                                optionCount++;
                                            }
                                        }

                                        if (optionCount == 0) {
                                            this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                                            return false;
                                        }
                                    }
                                    else {
                                        let val = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value : null;
                                        let keydownPattern = el.fieldConfig ? JSON.parse(el.fieldConfig).keydownPattern : '';

                                        if (el.fieldTypeCode == FieldTypeCode.NUMBER || el.fieldTypeCode == FieldTypeCode.NUMBER_CURRENCY) {
                                            if (val == "0" || val == 0) {
                                                this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                                                return false;
                                            }
                                        }
                                        if (val == undefined || val == 'undefined') {
                                            this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                                            return false;
                                        }
                                        else {
                                            if (!val) {
                                                this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                                                return false;
                                            }
                                            else if (keydownPattern && el.fieldTypeCode != FieldTypeCode.DATE && el.fieldTypeCode != FieldTypeCode.DATETIME) {
                                                let regex = new RegExp(keydownPattern.toString());
                                                let valid = regex.test(val);
                                                if (!valid) {
                                                    this.nzModalNotification.error("Error", component_name + " không đúng định dạng !");
                                                    return false;
                                                }
                                            }
                                        }
                                    }

                                }
                            }

                        }
                    }
                    else if (el.fieldTypeCode == FieldTypeCode.MULTIPLE_CHOICE) {
                        let optionCount = 0;
                        for (const opt of el.customfieldOptionList) {
                            let isChecked = this.formGroup.controls[el.fieldCode + '-' + opt.optionCode].value;
                            if (isChecked) {
                                optionCount++;
                            }
                        }

                        if (optionCount == 0) {
                            this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                            return false;
                        }
                    } else {
                        let val = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value : null;
                        let keydownPattern = el.fieldConfig ? JSON.parse(el.fieldConfig).keydownPattern : '';

                        if (el.fieldTypeCode == FieldTypeCode.NUMBER || el.fieldTypeCode == FieldTypeCode.NUMBER_CURRENCY) {
                            if (val == "0" || val == 0) {
                                this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                                return false;
                            }
                        }
                        if (val == undefined || val == 'undefined') {
                            this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                            return false;
                        }
                        else {
                            if (!val) {
                                this.nzModalNotification.error("Error", `Vui lòng nhập ${component_name} !`);
                                return false;
                            }
                            else if (keydownPattern && el.fieldTypeCode != FieldTypeCode.DATE && el.fieldTypeCode != FieldTypeCode.DATETIME) {
                                let regex = new RegExp(keydownPattern.toString());
                                let valid = regex.test(val);
                                if (!valid) {
                                    this.nzModalNotification.error("Error", component_name + " không đúng định dạng !");
                                    return false;
                                }
                            }
                        }
                    }
                }
            }

        }

        return true;
    }

    hasValue(controlName: string, nameValue: string) {
        if (nameValue && nameValue.indexOf(FieldTypeCode.MULTIPLE_CHOICE) > -1) {
            let val = this.formGroup.controls[nameValue] ? this.formGroup.controls[nameValue].value : "";
            if (val) {
                return true;
            }

        }
        else if (nameValue && nameValue.indexOf(FieldTypeCode.RADIO_BUTTON) > -1) {
            let el = this.formFieldInfo.find(x => nameValue.indexOf(x.fieldCode) > -1);
            if (el) {
                let radioNameValue = nameValue.substring(el.fieldCode.length + 1);
                let val = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value : "";
                if (val && val == radioNameValue) {
                    return true;
                }
            }
        }
        else if (controlName) {
            if (this.formGroup.controls[controlName].value == undefined) {
                return false;
            }
            let val = this.formGroup.controls[controlName] ? this.formGroup.controls[controlName].value : "";
            if (val) {
                if (controlName.indexOf(FieldTypeCode.NUMBER) > -1 && (val == "0" || val == 0)) {
                    return false;
                } else {
                    return true;
                }
            }
        }

        return false;
    }

    hasSubValue(nameValue: string) {
        if (nameValue && nameValue.indexOf(FieldTypeCode.MULTIPLE_CHOICE) > -1) {
            return true;
        }
        else if (nameValue && nameValue.indexOf(FieldTypeCode.RADIO_BUTTON) > -1) {
            let el = this.formFieldInfo.find(x => nameValue.indexOf(x.fieldCode) > -1);
            if (el) {
                let val = this.formGroup.controls[el.fieldCode] ? this.formGroup.controls[el.fieldCode].value : "";
                if (val) {
                    return true;
                }
            }
        }
        else if (nameValue) {
            if (this.formGroup.controls[nameValue].value == undefined) {
                return false;
            }
            let val = this.formGroup.controls[nameValue] ? this.formGroup.controls[nameValue].value : "";
            if (val) {
                if (nameValue.indexOf(FieldTypeCode.NUMBER) > -1 && (val == "0" || val == 0)) {
                    return false;
                } else {
                    return true;
                }
            }
        }
        return false;
    }


    stepIndexChange(index: number) {
        this.currentStep = index;
        localStorage.setItem(STORAGE_STEP + this.code + '_' + this.taxCode, this.currentStep.toString());
    }
}